// 登录
import login from '@/views/base/login';
// 结构
import index from '@/views/base/index';
// 首页
import home from '@/views/base/home';
// 错误页面
import error from '@/views/base/error';
// 内容页面
import content from './content.js';
// 内容页面
import about from '@/views/base/about';

export default [{
		path: '/',
		name: '',
		component: index,
		meta: {
			requireAuth: false,
			title: '小肥仔本仔'
		},
		children: [{
				path: '/',
				name: 'index',
				component: home,
				meta: {
					requireAuth: false,
					title: '首页'
				}
			},
			...content, {
				path: '/aboutit',
				name: 'about',
				component: about,
				meta: {
					requireAuth: false,
					title: '关于站点'
				}
			},
		]
	},
	{
		path: '/login',
		name: 'login',
		component: login,
		hidden: true,
		meta: {
			requireAuth: false,
		}
	},
	{
		path: '/403',
		name: '403',
		component: error,
		meta: {
			requireAuth: false,
			title: '403'
		}
	},
	{
		path: '*',
		name: '404',
		component: error,
		meta: {
			requireAuth: false,
			title: '404'
		}
	}
]
